
































































declare var window: any;
import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '../store.vuex';

const Container = () => {
  const version = vxm.utility.useLoginSignupV2 ? 'v2/' : '';
  return import(`./Registration/${version}Container.vue`);
};

const RegistrationCard = () => {
  const version = vxm.utility.useLoginSignupV2 ? 'v2/' : '';
  return import(`./Registration/${version}Card.vue`);
};
const CardHeader = () => {
  const version = vxm.utility.useLoginSignupV2 ? 'v2/' : '';
  return import(`./Registration/${version}Header.vue`);
};
import SsoLogin from './Registration/SsoLogin.vue';
import SignupForm from './Registration/SignupForm.vue';
import SignupFooter from './Registration/SignupFooter.vue';
import { User } from '../models/userdata/userdto';

import router from '../router';
import FindJobsLink from './Registration/FindJobsLink.vue';
import { UserParams } from '@/models/userdata/userparams';
import TermsAndConditionModal from '@/components/Commons/TermsAndConditionModal.vue';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import SignupFormV2 from './Login/v2/SignupFormV2.vue';
import AccountDisabled from './Registration/AccountDisabled.vue';
declare var window: any;
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000,
});
@Component({
  name: 'Signup',
  components: {
    TermsAndConditionModal,
    Container,
    RegistrationCard,
    CardHeader,
    SsoLogin,
    SignupForm,
    SignupFormV2,
    SignupFooter,
    FindJobsLink,
    AccountDisabled,
  },
})
export default class Signup extends Vue {
  private wlUser: User = new User();
  private userParams: UserParams = new UserParams();
  $wlToastr: any;
  private errorString: string = '';
  private socialRegistrationType: string = '';
  private socialRegistration: boolean = false;
  private isEmailSystemGenerated: boolean = true;
  private isMobileScreen: boolean = false;
  private userDataFetched: boolean = false;
  private errors = {
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  };
  private nameValdiation :boolean = false;
  private isEnabled: boolean = true;
  $refs!: {
    signupForm: HTMLFormElement;

  };

  get companyName(): String {
    return vxm.utility.companyName;
  }

  get tagLine() {
    return this.canShowSignupV2
      ? null
      : vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }
  get canShowFindJobs() {
    return !vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
  }
  validationName() {
    var copiedfirstName =   this.wlUser.firstName 
    var copiedLastName = this.wlUser.lastName
  var formattedString = copiedfirstName.replace(/[^a-zA-Z0-9\s]/g, '')
  var formattedLastName = copiedLastName.replace(/[^a-zA-Z0-9\s]/g, '')
    if(copiedfirstName.length!=formattedString.length){
      this.$refs.signupForm.verifyNames()
      this.nameValdiation =false

    return false;
  }
  else if(copiedLastName.length != formattedLastName.length){
    this.$refs.signupForm.verifyNames()
    this.nameValdiation =false


    return false;
  }
  this.nameValdiation =true

  return true;
}

  validateRegistrationData(user: User, confirmPassword): boolean {
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const hasNumber = user.password.match(/\d+/g);
    const hasLetter = user.password.match(/[a-zA-Z]/g);
    const hasUpperCase = user.password.match(/[A-Z]/g);
    let hasSpecialCharacter = user.password.match(/[@%+/'!#$^?:,(){}[~`_-]/g);
    // let allowedSpecialChars = /[@%+/'!#$^?:,(){}[~`_-]/g;
    let specialChars = user.password.match(/[\_\W]/g);
    let isValid: boolean = true;
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (
      user.password.length <
        vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
      (hasNumber == null && !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
      hasLetter == null ||
      (hasUpperCase == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
      (hasSpecialCharacter == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS')) || ((hasSpecialCharacter && specialChars && hasSpecialCharacter.length != specialChars.length) &&  !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
    ) {
      this.errors.password = vxm.utility.passwordConditions;
    }
    if (!user.password) {
      this.errors.password = 'signup.password.required';
    }
    if (user.password !== confirmPassword) {
      this.errors.confirmPassword = 'signup.password.confirmation.equivalent';
    }
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }

  landInPostSignupPage() {
    let homePage: any;
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      homePage = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (route) => route.sectionKey === 'HOME',
      );
    } else {
      homePage = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
        (route) => route.alias === 'home',
      );
    }
    const url = this.$cookies.get('NavigateTo_ID');

    if (
      vxm.utility.IsNewlyRegisteredUser &&
      this.$cookies.get('SubmitJobApplicationId') &&
      url
    ) {
      const [subpath, id] = url.split(':');
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: id },
      });
      return;
    } else if (
      vxm.utility.IsNewlyRegisteredUser &&
      vxm.configs.GuidedSignupEnabled
    ) {
      this.$router.push({ name: 'GuidedSignup' });
      return;
    } else if (url) {
      const [, id] = url.split(':');
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: id },
      });
      this.$cookies.remove('NavigateTo_ID');
      return;
    } else if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'FIND_JOBS'
    ) {
      this.$router.push({ name: 'Findjobs' });
      return;
    }
    if (homePage && homePage.signInVisibility) {
      this.$router.push({ name: 'Home' });
      return;
    }
    this.$router.push({ name: 'Findjobs' });
  }
  postSignupAction(message) {
    vxm.utility.setIsNewlyRegisterdUser(true);
    vxm.users.Rudderstack.trackEvent("Account Signup Completed", {})
    this.$wlToastr('success', message, 'Sign Up');
    if (vxm.utility.useLoginSignupV2) {
      if (this.userParams.isSocialMediaSignup) {
        this.landInPostSignupPage();
      } else {
        this.$router.push({
          name: 'OTPLogin',
          params: { username: this.wlUser.userName },
        });
      }
    } else if (
      vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION') &&
      vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION').includes('1')
    ) {
      this.landInPostSignupPage();
    } else {
      this.$router.push({ name: 'AnonVerification' });
    }
  }
  showTermsAndConditionPopup() {
    this.$bvModal.show('terms-service-modal');
  }
  register(confirmPassword) {
    this.validationName()
    this.userParams.email = this.wlUser.userName;
    if (this.wlUser.firstName) {
      this.wlUser.firstName = this.wlUser.firstName.trim();
    }
    if (this.wlUser.lastName) {
      this.wlUser.lastName = this.wlUser.lastName.trim();
    }
    this.userParams.firstName = this.wlUser.firstName;
    this.userParams.lastName = this.wlUser.lastName;
    this.userParams.phone = this.wlUser.phone;
    this.userParams.password = this.wlUser.password;
    this.wlUser.completeRegistration = this.canShowSignupV2
      ? true
      : vxm.users.getUiid && vxm.users.getUiid != 'null'
      ? true
      : false;

    if (this.canShowSignupV2) {
      vxm.users.setRouterAfterOTPForm(vxm.users.getDefaultRouterAfterOTPForm);
    }
    if (this.socialRegistrationType === 'facebook') {
      this.userParams.isSocialMediaSignup = true;
      this.userParams.socialMediaType = 'facebook';
      this.userParams.email = this.wlUser.email;
      vxm.users.setUserParams(this.userParams);
      if (!this.validateOAuthRegistrationData(this.wlUser)) {
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      return this.registerFacebook();
    } else if (this.socialRegistrationType === 'google') {
      this.userParams.isSocialMediaSignup = true;
      this.userParams.socialMediaType = 'google';
      this.userParams.email = this.wlUser.email;
      vxm.users.setUserParams(this.userParams);
      if (!this.validateOAuthRegistrationData(this.wlUser)) {
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      return this.registerGoogle();
    } else if (this.socialRegistrationType === 'linkedin') {
      this.userParams.isSocialMediaSignup = true;
      vxm.users.setUserParams(this.userParams);
      if (!this.validateOAuthRegistrationData(this.wlUser)) {
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      return this.registerLinkedin();
    } else if (this.socialRegistrationType === 'apple') {
      this.userParams.isSocialMediaSignup = true;
      vxm.users.setUserParams(this.userParams);
      if (!this.validateOAuthRegistrationData(this.wlUser)) {
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      return this.registerApple();
    } else {
      this.userParams.isSocialMediaSignup = false;
      vxm.users.setUserParams(this.userParams);
      const vm = this;

      if (vm.validateRegistrationData(vm.wlUser, confirmPassword)) {
        // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
        if (false) {
          this.showTermsAndConditionPopup();
          return;
        }
      setTimeout(()=>{
        if(this.nameValdiation){

this.sendRegistrationData();
}
      },50)

     
    }
    }
  }

  onAcceptTermsAndCondition() {
    this.$bvModal.hide('terms-service-modal');
    if (this.socialRegistrationType === 'facebook') {
      this.registerFacebook();
    } else if (this.socialRegistrationType === 'google') {
      this.registerGoogle();
    } else if (this.socialRegistrationType === 'linkedin') {
      this.registerLinkedin();
    } else if (this.socialRegistrationType === 'apple') {
      this.registerApple();
    } else {
      this.sendRegistrationData();
    }
  }

  sendRegistrationData() {
    //Below code we are removing to fix referral issue. Fixed in 4.8.4.1 branch.
    const respPromise: any = vxm.users.registerUser(this.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'RetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          this.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        this.postSignupAction(values[0].successMessage);
      }
    });
  }

  registerFacebook() {
    const vm = this;
    const respPromise: any = vxm.users.registerFacebookUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      console.log([values]);
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'RetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        this.postSignupAction(values[0].successMessage);
      }
    });
  }
  registerGoogle() {
    const vm = this;
    const respPromise: any = vxm.users.registerGoogleUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'RetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        this.postSignupAction(values[0].successMessage);
      }
    });
  }
  registerLinkedin() {
    const vm = this;
    vm.wlUser.duplicateCheckRequired = this.duplicateCheckRequired;
    const respPromise: any = vxm.users.registerLinkedInUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'RetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        this.postSignupAction(values[0].successMessage);
      }
    });
  }
  async registerApple() {
    const response: any = await vxm.users.registerAppleUser(
      this.wlUser,
      this.$route.query.code,
    );
    if (!response.success) {
      if (response.errorCode === 'Phone Linked With Another Email') {
        router.push({ name: 'RetrieveOldEmailConfirmation' });
      } else {
        const errorMessageText = response.errorMessage;
        this.$wlToastr('error', errorMessageText, 'Sign Up');
      }
    } else {
      this.postSignupAction(response.successMessage);
    }
  }

  validateOAuthRegistrationData(user: User): boolean {
    let isValid: boolean = true;
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }
  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  setOAuthRegistrationType(rtype: string) {
    console.log('C setOAuthRegistrationType:', rtype);
    this.$cookies.set('OAuthRegistrationType', rtype, 300);
  }
  getOAuthRegistrationType(): string {
    return this.$cookies.get('OAuthRegistrationType');
  }
  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }
  get isPartialSignup() {
    console.log(vxm.users.isPartialSignup, 'partial signup');
    return vxm.users.isPartialSignup;
  }

  get duplicateCheckRequired() {
    console.log(
      'duplicate check required value is : ',
      vxm.users.UserParams.checkForDuplicate,
    );
    return vxm.users.UserParams.checkForDuplicate;
  }

  get populateSignupPage() {
    console.log(
      'populate signup page value is : ',
      vxm.users.UserParams.populateSignupPage,
    );
    return vxm.users.UserParams.populateSignupPage;
  }

  beforeMount() {
    console.log("before mount");
    var basepath = window.location.href;
    if (
      vxm.configs.getGlobalConfigValue('ENABLE_ROLEBASED_REGISTRATION') &&
      window.WorkLLama.refId === 'null' &&
      window.WorkLLama.uuid === 'null'
    ) {
      this.$router.push({ name: 'RoleRegisterList' });
    }
    if(vxm.configs.getGlobalConfigValue('ENABLE_ROLEBASED_REGISTRATION') && basepath.includes('/signup?refId=')){
       this.$router.push({ name: 'RoleRegisterList' });
    }
  }

  mounted() {
    this.isMobileScreen = vxm.utility.isMobileDevice;
    this.socialRegistrationType = '';
    vxm.users
      .initRegisteredUser()
      .then((user: User) => {
        this.wlUser = user;
        this.isEnabled = this.wlUser.enabled;
        this.isEmailSystemGenerated = user.isEmailSystemGenerated;
        this.socialRegistration = false;
        this.userDataFetched = true;
        if (!this.isEnabled) {
          this.$router.push({ name: 'AccountDisabled' });
        }
      })
      .catch((error) => {
        this.userDataFetched = true;
        console.log('catch:', error);
      });
      this.wlUser.notificationTypeMap.WHATSAPP = vxm.configs.whatsappNotificationEnabled
    if (
      this.$route.query.firstName ||
      this.$route.query.lastName ||
      this.$route.query.email
    ) {
      if (this.$route.query.firstName) {
        this.wlUser.firstName = this.$route.query.firstName + '';
        vxm.users.setFirstName(this.$route.query.firstName + '');
      }
      if (this.$route.query.lastName) {
        this.wlUser.lastName = this.$route.query.lastName + '';
        vxm.users.setLastName(this.$route.query.lastName + '');
      }
      if (this.$route.query.email) {
        this.wlUser.email = this.$route.query.email + '';
        vxm.users.setEmail(this.$route.query.email + '');
      }

      if (this.$route.query.emailVerified) {
        this.wlUser.emailVerified = this.$route.query.emailVerified + '';
      }
      this.wlUser.phone = vxm.users.UserParams.phone;
      this.wlUser.duplicateCheckRequired = this.duplicateCheckRequired;
    } else if (this.populateSignupPage) {
      let userParams = vxm.users.UserParams;
      this.wlUser.firstName = userParams.firstName;
      this.wlUser.lastName = userParams.lastName;
      this.wlUser.email = userParams.email;
      this.wlUser.phone = userParams.phone;
      this.wlUser.password = userParams.password;
      this.wlUser.duplicateCheckRequired = this.duplicateCheckRequired;
    }

    const OAuthRegistrationType = this.$route.query.OAuthRegistrationType + '';
    const OAuthProvider = this.$route.query.OAuthProvider + '';
    console.log('OAuthRegistrationType:', OAuthRegistrationType);
    console.log('getOAuthProvider:', this.getOAuthProvider());
    if (
      OAuthRegistrationType === 'google-register' ||
      OAuthProvider === 'google'
    ) {
      this.socialRegistration = true;
      this.socialRegistrationType = 'google';
      this.setOAuthRegistrationType('');
      this.setOAuthProvider('');
    }

    if (
      OAuthRegistrationType === 'facebook-register' ||
      OAuthProvider === 'facebook'
    ) {
      this.socialRegistration = true;
      this.socialRegistrationType = 'facebook';
      this.setOAuthRegistrationType('');
      this.setOAuthProvider('');
    }

    if (
      OAuthRegistrationType === 'linkedin-register' ||
      OAuthProvider === 'linkedin'
    ) {
      this.socialRegistration = true;
      this.socialRegistrationType = 'linkedin';
      this.setOAuthRegistrationType('');
      this.setOAuthProvider('');
    }

    if (this.getOAuthProvider() === 'apple') {
      this.socialRegistration = true;
      this.socialRegistrationType = 'apple';
      this.setOAuthRegistrationType('');
      this.setOAuthProvider('');
    }
  }
  googleLogin() {
    this.setOAuthProvider('google');
    return vxm.users.loginWithGoogle();
  }
  facebookLogin() {
    this.setOAuthProvider('facebook');
    return vxm.users.loginWithFacebook();
  }
  linkedinLogin() {
    this.setOAuthProvider('linkedin');
    return vxm.users.loginWithLinkedin();
  }
  loginWithApple() {
    this.$cookies.set('OAuthProvider', 'apple', 300);
    return vxm.users.loginWithApple();
  }

  get canShowSignupV2(): boolean {
    return vxm.utility.useLoginSignupV2;
  }
}
